<template>
    <div class="mt-10 mr-10">
        <highcharts class="chart" :options="chartsetting" ref="lineCharts"></highcharts>  
    </div>
</template>

<script>

import HighchartHelper from "../../../helpers/settings/highchart";
import * as moment from "moment";

export default {
  name: 'SensorStatusGraph',
  props: {
    series:{}, 
    plotBands: []
  },
  data() {
    return {
      chartsetting: HighchartHelper.xssettings(this.series.name + " " + this.$t('last24h'), this.series.plotBands, this.series.max)
    };
  },
  mounted() {
 
    this.chartsetting.chart.height = 200;
    this.loadInitialData();
  },
  watch: {
    series() {
        this.loadInitialData();
    }
  },
  methods: {
    async loadInitialData () {

        //clear previous values
        var series_ids = [];
        for (var s in this.$refs.lineCharts.chart.series) {
            series_ids.push(this.$refs.lineCharts.chart.series[s].options.id);
        }
        for (var id in series_ids) {
            this.$refs.lineCharts.chart.get(series_ids[id]).remove(true);
        } 
        this.$refs.lineCharts.chart.addSeries({id: this.series.name, name: this.series.name , data: this.series.data, visible: true}); 
    },
  },

};
</script>



